import { type Image } from '@/interfaces';

export const broknByJMainImages: ReadonlyArray<Image> = Object.freeze([
  {
    altText: 'images.altText.stoneSilver',
    imageDirectoryPath: 'brokn-by-j-white',
    extension: 'png',
    width: 800,
    height: 534,
    class: 'w-full h-64',
    aspectRatio: 'horizontal',
    contents: [{ text: 'broknByJ.ringHistory.content' }],
    animation: 'fade-right'
  },
  {
    altText: 'images.altText.ringSketch',
    imageDirectoryPath: 'brokn-by-j-blue',
    extension: 'png',
    width: 800,
    height: 534,
    class: 'right w-full h-64',
    contents: [{ title: 'broknByJ.firstHandSet.title', text: 'broknByJ.firstHandSet.content' }],
    animation: 'fade-left'
  },
  {
    altText: 'images.altText.ringsSilverDiamonds',
    imageDirectoryPath: 'brokn-by-j-silver',
    extension: 'png',
    width: 400,
    height: 350,
    class: 'w-full h-64',
    contents: [
      { title: 'broknByJ.finalProduct.title', text: 'broknByJ.finalProduct.content', italic: true },
      { title: 'broknByJ.finalProduct.title2', text: 'broknByJ.finalProduct.content2' }
    ],
    animation: 'fade-right'
  }
]);
